import kuchyna2 from "@/assets/realizacie/realizaca-kuchyna-2.png.asset.json";
import kupelnaRekon from "@/assets/realizacie/realizacacia-kupelna-rekonstrukcia.png.asset.json";
import chodba from "@/assets/realizacie/realizacai-chodba.png.asset.json";
import dlazba from "@/assets/realizacie/realizacai-dlazba.png.asset.json";
import domPodlaha from "@/assets/realizacie/realizacai-dom-podlaha.png.asset.json";
import kuchynskaLinka from "@/assets/realizacie/realizacai-kuchynsak-linka.png.asset.json";
import rekonKuchyne1 from "@/assets/realizacie/realizacai-rekonstrukcia-kuchyne.png.asset.json";
import rekonKupelne from "@/assets/realizacie/realizacai-rekonstrukcia-kupelne.png.asset.json";
import zamok2 from "@/assets/realizacie/realizacai-zamok-rekonstrukcia-2.png.asset.json";
import zamok1 from "@/assets/realizacie/realizacai-zamok-rekonstrukcia.jpeg.asset.json";
import balkonoveDvere from "@/assets/realizacie/realizacia-balkonove-dvere.png.asset.json";
import kuchyna3 from "@/assets/realizacie/realizacia-kuchyna-3.png.asset.json";
import kuchyna from "@/assets/realizacie/realizacia-kuchyna.png.asset.json";
import kupelnaZachod from "@/assets/realizacie/realizacia-kupelna-zachod.png.asset.json";
import malovanie from "@/assets/realizacie/realizacia-malovanie.png.asset.json";
import rekonKuchyne2 from "@/assets/realizacie/realizacia-rekonstrukcia-kuchyne.png.asset.json";
import rekonSpalne from "@/assets/realizacie/realizacia-rekonstrukcia-spalne.png.asset.json";
import stavba2 from "@/assets/realizacie/realizacia-stavba-2.png.asset.json";
import stavbaStrecha from "@/assets/realizacie/realizacia-stavba-strecha.png.asset.json";
import stropu from "@/assets/realizacie/realizacia-stropu.png.asset.json";
import zachodovaMisa from "@/assets/realizacie/realizacia-zachodova-mysa.png.asset.json";

export type GalleryItem = { src: string; alt: string };

export const realizacieGallery: GalleryItem[] = [
  { src: kupelnaRekon.url, alt: "Rekonštrukcia modernej kúpeľne" },
  { src: kuchyna.url, alt: "Kuchyňa na mieru" },
  { src: stavbaStrecha.url, alt: "Stavba a realizácia strechy" },
  { src: domPodlaha.url, alt: "Pokládka podlahy v rodinnom dome" },
  { src: kuchyna2.url, alt: "Realizácia kuchyne" },
  { src: rekonKupelne.url, alt: "Rekonštrukcia kúpeľne" },
  { src: zamok1.url, alt: "Rekonštrukcia historického zámku" },
  { src: chodba.url, alt: "Realizácia chodby" },
  { src: dlazba.url, alt: "Pokládka dlažby" },
  { src: kuchynskaLinka.url, alt: "Kuchynská linka na mieru" },
  { src: rekonKuchyne1.url, alt: "Rekonštrukcia kuchyne" },
  { src: zamok2.url, alt: "Rekonštrukcia zámku" },
  { src: balkonoveDvere.url, alt: "Montáž balkónových dverí" },
  { src: kuchyna3.url, alt: "Realizácia kuchyne" },
  { src: kupelnaZachod.url, alt: "Rekonštrukcia kúpeľne a WC" },
  { src: malovanie.url, alt: "Maliarske práce" },
  { src: rekonKuchyne2.url, alt: "Rekonštrukcia kuchyne" },
  { src: rekonSpalne.url, alt: "Rekonštrukcia spálne" },
  { src: stavba2.url, alt: "Stavebné práce" },
  { src: stropu.url, alt: "Realizácia stropu" },
  { src: zachodovaMisa.url, alt: "Inštalácia sanity" },
];

export const realizacieStats = [
  { value: 300, suffix: "+", label: "Dokončených realizácií" },
  { value: 8, suffix: "+", label: "Rokov skúseností" },
  { value: 4.8, suffix: "★", label: "Hodnotenie klientov", decimals: 1 },
];
